import _ from 'lodash'
import { createAction } from 'redux-actions'
import log from 'sentry/log'
import { SMS_AND_BANKID, BANKID, SMS } from 'constants/verificationTypes'

import { actionCreators as api } from 'reduxBits/api'
import { errorHandler as chatErrorHandler } from 'reduxBits/chat/actions'

const prefix = 'Account:'
export const REQUEST_USER_INFORMATION = `${prefix} Request user information.`
export const RECEIVE_USER_INFORMATION = `${prefix} Receive user information.`
export const REQUEST_UPDATE_ACCOUNT = `${prefix} Request update account`
export const RECEIVE_UPDATE_ACCOUNT = `${prefix} Receive update account`
export const RECEIVE_UPDATE_ACCOUNT_ERROR = `${prefix} Receive update account with error`
export const SET_VERIFICATION_STATUS = `${prefix} Set verification status for user.`
export const SET_VERIFICATION_TYPE = `${prefix} Set verification type.`

const requestUserInformation = createAction(REQUEST_USER_INFORMATION)
const receiveUserInformation = createAction(RECEIVE_USER_INFORMATION)
const requestUpdateAccount = createAction(REQUEST_UPDATE_ACCOUNT)
const receiveUpdateAccount = createAction(RECEIVE_UPDATE_ACCOUNT)
const receiveUpdateAccountError = createAction(RECEIVE_UPDATE_ACCOUNT_ERROR)
const setVerificationStatus = createAction(SET_VERIFICATION_STATUS)
export const setVerificationType = createAction(SET_VERIFICATION_TYPE)

const fetchUserInformation = (forceRefresh = false) => (dispatch) => {
  dispatch(requestUserInformation())
  return dispatch(api.fetch(`auth/v1/me?force_refresh=${forceRefresh}`)).then(
    (response) => dispatch(receiveUserInformation(response.data)),
    (error) => {
      log.error(error)
      dispatch(receiveUserInformation(error))
    },
  )
}

/**
 * Updates the blocket settings of the account
 *
 * @param {object} updatedProperties - the properties to update with its new values
 */
const updateAccountSettings = (updatedProperties) => (dispatch, getState) => {
  // Setup model to send to API
  const settingsModel = {
    ...{
      region: getState().account.user.propertyMap.region,
      munic: getState().account.user.propertyMap.munic,
      subarea: getState().account.user.propertyMap.subarea,
      accept_newsletter: getState().account.user.propertyMap.acceptNewsletter,
      mc_send_email_copy: getState().account.user.propertyMap.mcSendEmailCopy,
      account_id: getState().account.user.propertyMap.accountId,
      adwatch_mail_summary: getState().account.user.propertyMap.adwatchMailSummary,
    },
    ...(_.isUndefined(updatedProperties) ? {} : updatedProperties),
  }

  // Set region, munic and region to str "0" when they are empty to avoid trans error
  settingsModel.region = _.isEmpty(settingsModel.region) ? '0' : settingsModel.region
  settingsModel.munic = _.isEmpty(settingsModel.munic) ? '0' : settingsModel.munic
  settingsModel.subarea = _.isEmpty(settingsModel.subarea) ? '0' : settingsModel.subarea

  // Send post to blocket API
  dispatch(requestUpdateAccount())
  return dispatch(
    api.fetch('auth/v1/me/property_map', {
      method: 'PUT',
      body: JSON.stringify(settingsModel),
    }),
  ).then(
    () => {
      dispatch(receiveUpdateAccount())
      dispatch(fetchUserInformation(true))
    },
    (error) => {
      log.error(error)
      dispatch(receiveUpdateAccountError(error))
    },
  )
}

export const fetchVerficationStatus = () => async (dispatch) => {
  const endpoint = 'auth/v1/user/verified'
  try {
    const response = await dispatch(api.fetch(endpoint))
    const { account, session } = response
    const bankIdAccountVerified = account?.verifiedByBankid
    const bankIdSessionVerified = session?.verifiedByBankid
    const smsSessionVerified = session?.verifiedBySms

    dispatch(setVerificationStatus({ account, session }))

    if ((bankIdAccountVerified && bankIdSessionVerified) || smsSessionVerified) {
      // no verifcation needed
      return dispatch(setVerificationType({ type: '' }))
    }

    if (!smsSessionVerified && !bankIdAccountVerified) {
      return dispatch(setVerificationType({ type: SMS_AND_BANKID }))
    }

    if (bankIdAccountVerified && !bankIdSessionVerified) {
      return dispatch(setVerificationType({ type: BANKID }))
    }

    if (!smsSessionVerified) {
      return dispatch(setVerificationType({ type: SMS }))
    }
  } catch (error) {
    dispatch(
      chatErrorHandler({
        errorType: 'general',
        error,
        sentryLog: { description: `Error when calling ${endpoint}: ${error}` },
      }),
    )
  }
}

export const actionCreators = {
  fetchUserInformation,
  receiveUserInformation,
  updateAccountSettings,
  fetchVerficationStatus,
}
